var map = {
	"./Complete Hiragana Practice Tracing Sheet.pdf": 62172,
	"./Complete Hiragana Practice Writing Sheet (Blank).pdf": 11809,
	"./Complete Hiragana Stroke Order Practice Tracing Sheet.pdf": 67824,
	"./Complete Katakana Practice Tracing Sheet.pdf": 72773,
	"./Complete Katakana Practice Writing Sheet (Blank).pdf": 59624,
	"./Complete Katakana Stroke Order Practice Tracing Sheet.pdf": 74663,
	"./Hiragana Character Chart.pdf": 51254,
	"./Hiragana Katakana Kanji Blank Practice Sheet.pdf": 24162,
	"./Japanese Character Practice Writing Sheet (Blank).pdf": 72955,
	"./Katakana Character Chart.pdf": 38001,
	"./Vertical Writing 12_18 Grid.pdf": 31533,
	"./Vertical Writing 18_12 Grid.pdf": 99481,
	"./Vertical Writing 9_6 Grid With Dashed Guides.pdf": 15528,
	"./Vertical Writing Sheet 6_9 Squares With Dashed Guides.pdf": 33279,
	"./hiragana_a.pdf": 46295,
	"./hiragana_ba.pdf": 39797,
	"./hiragana_be.pdf": 15937,
	"./hiragana_bi.pdf": 1021,
	"./hiragana_bo.pdf": 66523,
	"./hiragana_bu.pdf": 34385,
	"./hiragana_chi.pdf": 91272,
	"./hiragana_da.pdf": 22039,
	"./hiragana_de.pdf": 43971,
	"./hiragana_di.pdf": 29055,
	"./hiragana_do.pdf": 86041,
	"./hiragana_du.pdf": 31411,
	"./hiragana_e.pdf": 48995,
	"./hiragana_fu.pdf": 7037,
	"./hiragana_ga.pdf": 64606,
	"./hiragana_ge.pdf": 48146,
	"./hiragana_gi.pdf": 74006,
	"./hiragana_go.pdf": 2240,
	"./hiragana_gu.pdf": 42818,
	"./hiragana_ha.pdf": 40011,
	"./hiragana_he.pdf": 63871,
	"./hiragana_hi.pdf": 70883,
	"./hiragana_ho.pdf": 21733,
	"./hiragana_i.pdf": 69663,
	"./hiragana_ji.pdf": 97797,
	"./hiragana_ka.pdf": 92018,
	"./hiragana_ke.pdf": 56894,
	"./hiragana_ki.pdf": 25930,
	"./hiragana_ko.pdf": 55772,
	"./hiragana_ku.pdf": 21710,
	"./hiragana_ma.pdf": 58516,
	"./hiragana_me.pdf": 87096,
	"./hiragana_mi.pdf": 45516,
	"./hiragana_mo.pdf": 84026,
	"./hiragana_mu.pdf": 23304,
	"./hiragana_n.pdf": 99956,
	"./hiragana_na.pdf": 62481,
	"./hiragana_ne.pdf": 92133,
	"./hiragana_ni.pdf": 30329,
	"./hiragana_no.pdf": 15871,
	"./hiragana_nu.pdf": 49045,
	"./hiragana_o.pdf": 84121,
	"./hiragana_pa.pdf": 20547,
	"./hiragana_pe.pdf": 98615,
	"./hiragana_pi.pdf": 81771,
	"./hiragana_po.pdf": 68909,
	"./hiragana_pu.pdf": 58535,
	"./hiragana_ra.pdf": 18821,
	"./hiragana_re.pdf": 47601,
	"./hiragana_ri.pdf": 79821,
	"./hiragana_ro.pdf": 29771,
	"./hiragana_ru.pdf": 79297,
	"./hiragana_sa.pdf": 58634,
	"./hiragana_se.pdf": 50582,
	"./hiragana_shi.pdf": 94680,
	"./hiragana_so.pdf": 14052,
	"./hiragana_su.pdf": 44646,
	"./hiragana_ta.pdf": 7591,
	"./hiragana_te.pdf": 31923,
	"./hiragana_to.pdf": 29065,
	"./hiragana_tsu.pdf": 12790,
	"./hiragana_u.pdf": 52787,
	"./hiragana_wa.pdf": 48750,
	"./hiragana_wo.pdf": 49776,
	"./hiragana_ya.pdf": 63216,
	"./hiragana_yo.pdf": 38510,
	"./hiragana_yopdf.pdf": 3288,
	"./hiragana_yu.pdf": 15100,
	"./hiragana_za.pdf": 45693,
	"./hiragana_ze.pdf": 48393,
	"./hiragana_zo.pdf": 51251,
	"./hiragana_zu.pdf": 31001,
	"./【あいうえおかきくけこ】T2W5(1).pdf": 36220,
	"./【がぎぐげござじずぜぞ】T2W5(6).pdf": 28446,
	"./【さしすせそたちつてと】T2W5(2).pdf": 98581,
	"./【だぢづでどばびぶべぼ】T2W5(7).pdf": 87666,
	"./【なにぬねのははひふへほ】T2W5(3).pdf": 9943,
	"./【ぱぴぷぺぽ】T2W5(8).pdf": 97239,
	"./【まみむめもやゆよ】T2W5(4).pdf": 31514,
	"./【らりるれろわをん】T2W5(5).pdf": 62416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18716;